import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Tradable } from "@models/interfaces/tradable";
import { Timespan } from "@helpers/const/timespan";

@Component({
	selector: "most-popular-tradables",
	templateUrl: "./most-popular-tradables.component.html",
	styleUrls: ["./most-popular-tradables.component.scss"],
	standalone: false
})
export class MostPopularTradablesComponent {
	@Input() public mostPopularList: Tradable[] = [];

	@Output() public onTradableClick = new EventEmitter<Tradable>();

	public timespan = Timespan.Day;

	public onClick(tradable: Tradable): void {
		this.onTradableClick.emit(tradable);
	}
}
